export enum ErrorSeverityEnum {
  error = "error",
  warning = "warning",
  info = "info",
  success = "success",
}
